<div class="tw-w-full">
  @if (showMobileLayout) {
    <modal-header
      [title]="title"
      [subtitle]="subtitle"
      [showBackButton]="true"
      [showCloseButton]="false"
      [backButtonClass]="backButtonClass"
      [showEditButton]="showEditIcon"
      [titleClass]="titleClass"
      [forceMobileLayout]="true"
      (onBackClicked)="handleBackClick()"
      (onEditClicked)="onEditClicked.emit()"
    ></modal-header>
    @if (description) {
      <div
        class="tw-flex tw-flex-col tw-rounded-lg tw-pl-1 tw-pt-1 tw-bg-color-surface-elevated tw-mb-2 tw-mx-2 tw-shadow-card-elevated"
      >
        <div class="tw-rounded-xl tw-px-4 tw-py-3 tw-bg-color-surface-card">
          <span
            class="tw-text-sm tw-text-color-text-default tw-block tw-truncate"
            [title]="description"
            >{{ description }}</span
          >
        </div>
      </div>
    }
  } @else if (showDesktopHeader) {
    <div class="tw-flex tw-flex-wrap tw-items-center tw-pr-3 tw-my-2 tw-gap-3">
      <div class="tw-flex tw-items-center tw-shrink-0 tw-gap-2">
        @if (icon || headerIconName) {
          @if (headerIconClickable) {
            <button
              type="button"
              [attr.aria-label]="'goBack' | i18n"
              [class]="
                (headerIconWrapperClass ||
                  'tw-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 tw-rounded-lg tw-bg-transparent tw-text-color-icon-default') +
                ' tw-cursor-pointer tw-border-none tw-bg-transparent tw-p-0'
              "
              (click)="onHeaderIconClicked.emit()"
            >
              <icon [name]="icon || headerIconName" [size]="headerIconSize"></icon>
            </button>
          } @else {
            <div
              [class]="
                headerIconWrapperClass ||
                'tw-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 tw-rounded-lg tw-bg-transparent tw-text-color-icon-default'
              "
            >
              <icon [name]="icon || headerIconName" [size]="headerIconSize"></icon>
            </div>
          }
        }

        @if (showDeleteButton) {
          <div class="tw-flex tw-flex-col">
            <span class="tw-font-medium tw-text-lg tw-text-color-text-default">{{ title }}</span>
            @if (subtitle) {
              <span class="tw-font-normal tw-text-sm tw-text-color-text-secondary">{{
                subtitle
              }}</span>
            }
          </div>
        } @else {
          <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-1">
            <span class="tw-font-medium tw-text-lg tw-text-color-text-default">{{ title }}</span>
            @if (subtitle) {
              <span class="tw-font-normal tw-text-color-text-secondary">({{ subtitle }})</span>
            }
            @if (showEditIcon) {
              <button
                type="button"
                class="tw-flex tw-items-center tw-justify-center tw-p-1 tw-rounded-md tw-text-color-text-secondary hover:tw-bg-color-surface-sunken hover:tw-text-color-text-default tw-transition-colors tw-cursor-pointer tw-border-none tw-bg-transparent"
                aria-label="Edit"
                (click)="onEditClicked.emit()"
              >
                <icon [name]="'writing'" [size]="4"></icon>
              </button>
            }
          </div>
        }
      </div>

      @if (showDeleteButton) {
        <div class="tw-ml-auto tw-flex tw-items-center tw-gap-2">
          @if (showEditIcon) {
            <app-gloss-button
              [options]="editButtonOptions"
              [fontClass]="'tw-text-primary tw-flex-row-reverse'"
            ></app-gloss-button>
          }
          <app-gloss-button
            [options]="deleteButtonOptions"
            [fontClass]="'!tw-text-color-status-error-text tw-flex-row-reverse'"
          ></app-gloss-button>
        </div>
      } @else {
        <div class="tw-flex tw-flex-1 tw-items-center tw-gap-1.5 tw-min-w-0">
          <div class="tw-h-px tw-flex-1 tw-bg-pink-400 tw-rounded-full"></div>
          <div class="tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-pink-400 tw-flex-shrink-0"></div>
        </div>
      }
    </div>
  }

  <ng-content></ng-content>
</div>
